<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs4>
      <v-subheader>Expense Types</v-subheader>
    </v-flex>

    <v-flex xs8>
      <vu-list
        title="Expenses Types"
        :items="editSettings"
        editable
        :dense="false"
      />
    </v-flex>

    <v-flex xs12>
      <v-btn
        color="success"
        @click="save()"
      >
        Save
      </v-btn>
      <v-btn
        text
        @click="cancel()"
      >
        Cancel
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import VuList from '@/components/shared/VuList'

export default {
  components: {
    VuList
  },
  data () {
    return {
      editSettings: {}
    }
  },
  computed: {
    ...mapState('organizations', [
      'expenseTypes'
    ])
  },
  mounted () {
    this.cancel()
  },
  methods: {
    save () {
      for (let type in this.editSettings) {
        this.$store.dispatch('organizations/setExpenseTypes', this.editSettings[type])
      }
    },
    cancel () {
      this.editSettings = Object.assign({}, this.expenseTypes)
    }
  }
}
</script>

<style>

</style>
